import React, { useState } from "react";
import downloadIcon from "../../../../assets/icons/new_icon/download.svg";
import LmsLineItemsContainer from "../../line-item";
interface Props {
  barcode: any;
}
function LineItemView({ barcode }: Props) {
  return (
    <div className="ubbe-card accordion-border mt-5">
      <div
        className="accordion accordion-flush"
        style={{ backgroundColor: "transparent" }}
        id="shipment_document_accordion"
      >
        <div
          className="accordion-item border"
          style={{ backgroundColor: "transparent" }}
        >
          <h2 className="accordion-header" id="main_document_head">
            <div className="row align-items-center position-relative ">
              <div
                className="col-auto position-absolute z-3"
                style={{
                  right: "45px",
                  zIndex: "9999",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></div>
              <div className="col">
                <button
                  className={`accordion-button  col-12 
               "active"
                  }`}
                  style={{ backgroundColor: "#251163" }}
                  type="button"
                >
                  <h5
                    style={{ color: "white" }}
                    className="accordion-header boldsteppertext"
                    id="shipment_document_head"
                  >
                    Line Items{" "}
                  </h5>
                </button>
              </div>
            </div>
          </h2>

          <div
            id="main_document_body"
            className={`accordion-collapse collapse ${"show"}`}
            aria-labelledby="main_document_head"
            data-bs-parent="#main_leg_accordion"
          >
            <div className="accordion-body p-0 mt-2">
              <LmsLineItemsContainer itemView={true} barcodeValue={barcode} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LineItemView;
